module.exports = __webpack_public_path__ + "static/img/shi1_2.a5cc646.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shi1_2.png
// module id = H6DX
// module chunks = 1